export var PhotoCaptureAttributeType;
(function (PhotoCaptureAttributeType) {
    PhotoCaptureAttributeType["DEFAULT"] = "DEFAULT";
    PhotoCaptureAttributeType["ACKNOWLEDGEMENT"] = "ACKNOWLEDGEMENT";
    PhotoCaptureAttributeType["TERMINATE"] = "TERMINATE";
    PhotoCaptureAttributeType["VIN_CAPTURE"] = "VIN_CAPTURE";
    PhotoCaptureAttributeType["VIN_STICKER"] = "VIN_STICKER";
    PhotoCaptureAttributeType["MILEAGE_CAPTURE"] = "MILEAGE_CAPTURE";
    PhotoCaptureAttributeType["LICENSE_PLATE_CAPTURE"] = "LICENSE_PLATE_CAPTURE";
    PhotoCaptureAttributeType["SINGLE_WIDE_SHOT"] = "SINGLE_WIDE_SHOT";
    PhotoCaptureAttributeType["THREE_CLOSE_UP"] = "THREE_CLOSE_UP";
    PhotoCaptureAttributeType["FOUR_CORNERS_CAPTURE"] = "FOUR_CORNERS_CAPTURE";
    PhotoCaptureAttributeType["VIDEO_CAPTURE"] = "VIDEO_CAPTURE";
    PhotoCaptureAttributeType["VIN_DECODE"] = "VIN_DECODE";
    PhotoCaptureAttributeType["WIDE_ENHANCED"] = "WIDE_ENHANCED";
    PhotoCaptureAttributeType["CLOSEUP_ENHANCED"] = "CLOSEUP_ENHANCED";
    PhotoCaptureAttributeType["SELECT_SHOP"] = "SELECT_SHOP";
    PhotoCaptureAttributeType["SUMMARY"] = "SUMMARY";
    PhotoCaptureAttributeType["INTELLIGENT_FOUR_CORNERS_VEHICLE_IMAGE"] = "INTELLIGENT_FOUR_CORNERS_VEHICLE_IMAGE";
    PhotoCaptureAttributeType["INTELLIGENT_LICENCE_PLATE"] = "INTELLIGENT_LICENCE_PLATE";
    PhotoCaptureAttributeType["INTELLIGENT_VIN_LOCATIONS"] = "INTELLIGENT_VIN_LOCATIONS";
    PhotoCaptureAttributeType["INTELLIGENT_VEHICLE_MILEAGE"] = "INTELLIGENT_VEHICLE_MILEAGE";
    PhotoCaptureAttributeType["INTELLIGENT_DAMAGE_WIDESHOT"] = "INTELLIGENT_DAMAGE_WIDESHOT";
    PhotoCaptureAttributeType["INTELLIGENT_DAMAGE_CLOSEUP"] = "INTELLIGENT_DAMAGE_CLOSEUP";
    PhotoCaptureAttributeType["INTELLIGENT_ILLUSTRATION"] = "INTELLIGENT_ILLUSTRATION";
    PhotoCaptureAttributeType["INTELLIGENT_WELLITAREA"] = "INTELLIGENT_WELLITAREA";
    PhotoCaptureAttributeType["INTELLIGENT_APPRAISER_VIEW"] = "INTELLIGENT_APPRAISER_VIEW ";
})(PhotoCaptureAttributeType || (PhotoCaptureAttributeType = {}));
//# sourceMappingURL=PhotoCaptureAttributeType.js.map